import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppService } from '../service/AppService.class';

@Component({
  selector: 'FormDetail',
  templateUrl: './formdetail.component.html',
  styleUrls: ['./formdetail.component.css']
})
export class FormdetailComponent<T> implements OnInit {
  @Input() dataservice: AppService<T>;
  close_status: boolean;
  open_status:boolean;
  tag_label : string;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit() { 
    if(this.dataservice){
      this.dataservice.status.subscribe(res => {
        this.dataservice.debug_log("Add button clicked");
        this.close_status = res;
        this.close.emit(res);
        if (res)
          this.open_status = false;
        else
          this.open_status = true;
      });

      this.dataservice.changelabel("List Details");
      this.dataservice.label.subscribe(res => {
        this.tag_label = res;
      });
    }  
 
  }

  onClose()
  {
    this.dataservice.changelabel("List Details");
    this.dataservice.changefrm(false);
    this.dataservice.Data=null;
  }

  onAddNew()
  {
    this.dataservice.changelabel("Add New");
    this.dataservice.changefrm(true);
    this.dataservice.Data=null;
  }

  ngOnDestory()
  {
    this.dataservice.frm_label.unsubscribe();
    this.dataservice.frm_status.unsubscribe();
  }
}